import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import {privateRoutes} from '@/router/routes/private';
import {publicRoutes} from '@/router/routes/public';
import Store from "@/store";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/BaseView.vue'),
    redirect: { name: 'beni' },
    children: [
      privateRoutes,
      publicRoutes,
    ],
  },
  {
    path: '*',
    redirect: {name: 'login'}
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  let requiresAuth = false;
  if (to.matched) {
    requiresAuth = to.matched.map((e) => e.meta.requiresAuth).reduce((x, y) => x || y, false);
  }
  const userInVuex = Store.getters["TheLoggedUser/loggedUserAuthToken"];

  const userInStorageStr = localStorage.getItem('loggedUser');
  const userInStorage = !userInStorageStr ? null : JSON.parse(userInStorageStr);
  const tokenInStorage = localStorage.getItem('authToken') || '';

  if (requiresAuth && !userInStorage && !userInVuex) {
    // requires auth and no user info...
    return next({ name: 'login' });
  }
  else if (requiresAuth && userInVuex){
    // requires auth but user is in vuex
    return next();
  }
  else if (requiresAuth && userInStorage){
    // requires auth and user is in local storage
    Store.commit('TheLoggedUser/setUser', userInStorage);
    Store.commit('TheLoggedUser/setAuthToken', tokenInStorage);
    return next();
  }
  else {
    return next();
  }
});

export default router;
